import http from '@/services/http.js';

const VIDEO_API = '/videoapi/video';
const VIDEO_CREATE_API = '/videoapi/video/create';
const VIDEO_LIST_API = '/videoapi/video/list';
const VIDEO_STATUS_API = '/videoapi/video/status';

export const fetchOrderAutomation = async (clientId) => {
  const response = await http.get(`${VIDEO_API}/orders/${clientId}/automation`);
  return response.data.data;
};

export const submitOrderVideoProductionJob = async (
  clientId,
  slotValues,
  videoTemplateId
) => {
  const response = await http.post(VIDEO_CREATE_API, {
    client_id: clientId,
    slot_values: slotValues,
    video_template_id: videoTemplateId,
  });
  return response.data.data;
};

export const fetchVideoProductionJobs = async (params = {}) => {
  const response = await http.get(VIDEO_LIST_API, { params });
  const data = response.data.data || {};
  if (Array.isArray(data)) {
    return {
      items: data,
      pagination: {
        page: Number(params.page) || 1,
        limit: Number(params.limit) || data.length,
        total: data.length,
        totalPages: data.length > 0 ? 1 : 0,
      },
    };
  }
  return {
    items: data.items || [],
    pagination: data.pagination || {
      page: Number(params.page) || 1,
      limit: Number(params.limit) || 20,
      total: 0,
      totalPages: 0,
    },
  };
};

export const fetchOrderVideoProductionJobs = async (clientId, params = {}) => {
  return fetchVideoProductionJobs({
    ...params,
    client_id: clientId,
  });
};

export const fetchVideoProductionJob = async (jobId) => {
  const response = await http.get(`${VIDEO_STATUS_API}/${jobId}`);
  return response.data.data;
};

export const refreshVideoProductionJob = async (jobId) => {
  const response = await http.post(`${VIDEO_STATUS_API}/${jobId}/refresh`);
  return response.data.data;
};

export const downloadVideoProductionFile = async (jobId) => {
  const response = await http.get(
    `${VIDEO_API}/download/${encodeURIComponent(jobId)}`
  );
  const downloadUrl = response.data.data?.download_url;
  if (!downloadUrl) {
    throw new Error('下载地址不存在');
  }
  const link = document.createElement('a');
  link.href = downloadUrl;
  document.body.appendChild(link);
  link.click();
  link.remove();
};
